import PageDataContextService from "@core-ui/ContextServices/PageDataContext";
import SidebarsIsOpenService from "@core-ui/ContextServices/Sidebars/SidebarsIsOpenContext";
import type { LeftNavViewContentComponent } from "@core-ui/ContextServices/views/leftNavView/LeftNavViewContentService";
import t from "@ext/localization/locale/translate";
import { NavigationTree } from "@ext/navigation/catalog/SidebarNavigation/components/edit/NavigationTree";
import { ReadonlyNavigationTree } from "@ext/navigation/catalog/SidebarNavigation/components/render/ReadonlyNavigationTree";
import Layout from "../../../../extensions/navigation/catalog/main/render/Layout";

const LeftNavigationContent: LeftNavViewContentComponent = ({ itemLinks, closeNavigation }) => {
	const isOpen = SidebarsIsOpenService.value.left;
	const isReadOnly = PageDataContextService.value.conf.isReadOnly;

	return (
		// A landmark, so the article tree is addressable as one region: the same article title can
		// appear both here and in the article itself, and without it they are indistinguishable.
		<nav
			aria-label={t("catalog.navigation")}
			style={isOpen ? null : { paddingRight: "var(--left-navigation-content-padding-right)" }}
		>
			<Layout>
				{isReadOnly ? (
					<ReadonlyNavigationTree items={itemLinks} />
				) : (
					<NavigationTree closeNavigation={closeNavigation} items={itemLinks} />
				)}
			</Layout>
		</nav>
	);
};

export default LeftNavigationContent;
